import { render, staticRenderFns } from "./Filter-top.vue?vue&type=template&id=244f44f8&scoped=true&lang=pug"
import script from "./Filter-top.vue?vue&type=script&lang=js"
export * from "./Filter-top.vue?vue&type=script&lang=js"
import style0 from "./Filter-top.vue?vue&type=style&index=0&id=244f44f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244f44f8",
  null
  
)

export default component.exports